import { defineComponent as _defineComponent } from 'vue'
import { ref } from "vue";
import { VideoModal } from "@/ts/components/elements";

interface Props {
    vimeoId: string | number;
}


export default /*#__PURE__*/_defineComponent({
  props: {
    vimeoId: { type: [String, Number], required: true }
  },
  setup(__props: any, { expose }) {
  expose();

let show = ref(false);

const modal = ref({ open: false });



const __returned__ = { show, modal, VideoModal }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})